<template>
    <div role="tablist">
        <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button v-on:click="onToggle" block v-b-toggle.accordion-1 variant="default">
            PRODUCT INFORMATION
            <b-icon-dash class="when-opened"></b-icon-dash>
            <b-icon-plus class="when-closed"></b-icon-plus>
            </b-button>
        </b-card-header>
        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
            <ul class="unordered-list">
                <li>SantizerWristband is built for functionality while on-the-go.</li>
                <li>SantizerWristband is 9.25in (23.5cm) long and adjustable to all wrist sizes</li>
                <li>Adjustable strap makes it ideal for boys and girls, men and women. Kids can use it for back to school, vacations, and trips to the store; Adults can use it in the office, shopping, and anywhere washing hands is not an option.</li>
                <li>Comes with one refill bottle</li>
                <li>One fill can last 15-20 Uses</li>
                <li>It is washable, wearable and comes with two caps, one for loose liquids and the other for liquid gels. It can be filled over and over again with any brand hand sanitizer such as Germ X, Purell, Babyganics, and Pocketbac; Cute design makes it stylish and functional</li>
                <li>Fill with your liquid of choice and press on the wristband to dispense at your leisure.</li>
                <li>The band is ideal for those who travel, work in health care, service industries and just about anyone else.</li>
                <li>Makes the perfect gift for yourself and loved ones</li>
            </ul>
            </b-card-body>
        </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button v-on:click="onToggle" block v-b-toggle.accordion-2 variant="default">
            RETURN POLICY
            <b-icon-dash class="when-opened"></b-icon-dash>
            <b-icon-plus class="when-closed"></b-icon-plus>
            </b-button>
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
            <b-card-body>
            <b-card-text>
                Due to the nature of our product, we do not accept refunds or exchanges.
                However, if your product is received defective (and unused)
                we are willing to exchange it for you at no extra charge.
                If this happens, please email us directly at <a href="mailto:info@sanitizerwristband.com">info@sanitizerwristband.com</a></b-card-text>
            </b-card-body>
        </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button v-on:click="onToggle" block v-b-toggle.accordion-3 variant="default">
                SHIPPING INFORMATION
            <b-icon-dash class="when-opened"></b-icon-dash>
            <b-icon-plus class="when-closed"></b-icon-plus>
            </b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
            <b-card-body>
                <span><strong><em>*DUE TO COVID-19, PLEASE EXPECT UP TO A 4-6 WEEK DELAY IN DELIVERY*</em></strong></span><br>
                <span>Standard shipping rates are as follows:</span>
                <ul class="unordered-list">
                    <li>We make use of international standard shipping rate: $10.00 for all orders.</li>
                    <li>If your order is $100 (before applicable taxes), you'll receive <strong>FREE SHIPPING</strong>.</li>
                    <li><strong>ALL ORDERS</strong> are shipped via DHL standard shippin. We will let you know via email if anything changes. Please allow 9-15 business days for receipt of your order.</li>
                </ul>
            </b-card-body>
        </b-collapse>
        </b-card>
    </div>
</template>

<script>
export default {
  methods: {
    onToggle (e) {
      window.gtag('send', {
        hitType: 'event',
        eventCategory: 'Extra Product Info',
        eventAction: 'toggle',
        eventLabel: e.target.innerText
      })
      window.analytics.track('Toggle Product Info', {
        title: e.target.innerText
      })
    }
  }
}
</script>
<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ExtraProductInfo.vue